import protoRoot from "../proto-root";
import LullabyPlayerTimerSettings from "./LullabyPlayerTimerSettings";

function create({ serverId, timerSettings, volume }) {
  const LullabyPlayerSettings = protoRoot.lookupType(
    `comm.LullabyPlayerSettings`
  );

  return LullabyPlayerSettings.create({
    serverId,
    volume,
    timerSettings: LullabyPlayerTimerSettings.create(timerSettings)
  });
}

export default {
  create
};

// message LullabyPlayerSettings {
//   string serverId = 1;
//   LullabyPlayerTimerSettings timerSettings = 2;
//   double volume = 3;
// }
